module.exports = __webpack_public_path__ + "static/media/edit.0e7f010c.svg";